module.exports = __webpack_public_path__ + "static/media/collection.6cbb9cdb.svg";